export default "__VITE_ASSET__DH5RAeCi__"